module.exports = __webpack_public_path__ + "static/media/chart-bg.aba625f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/chart-bg.png
// module id = 660
// module chunks = 1